import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../components/Modal';
import CohortPresenter from '../../../presenters/CohortPresenter';

const CohortSelect = (props) => {
  const { modalOpen, closeModal, cohorts, onSelect } = props;

  const handleChange = (cohort) => {
    onSelect(cohort);
    closeModal();
  };

  return (
    <div>
      <Modal
        title="Select Cohort"
        onClose={() => closeModal()}
        isModalOpen={modalOpen}
      >
        <table className="tables">
          <thead>
            <tr>
              <th>Cohort Id</th>
              <th>Name</th>
              <th>Description</th>
              <th>Number of users</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {cohorts.map((cohort) => (
              <tr onClick={() => handleChange(cohort)}>
                <td>{cohort.id}</td>
                <td>{cohort.name}</td>
                <td>{cohort.description}</td>
                <td>{cohort.count}</td>
                <td>{cohort.created}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="top-margin">
          <text className="redText">
            Note: Changes made in Mixpanel take 15 minutes or more to refresh on
            this page.
          </text>
        </div>
      </Modal>
    </div>
  );
};

export default CohortSelect;

CohortSelect.propTypes = {
  cohorts: PropTypes.arrayOf(CohortPresenter.shape()),
  modalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
};

CohortSelect.defaultProps = {
  cohorts: [],
};
